import { render, staticRenderFns } from "./Cleanse.vue?vue&type=template&id=03c56b7a&scoped=true"
import script from "./Cleanse.vue?vue&type=script&lang=js"
export * from "./Cleanse.vue?vue&type=script&lang=js"
import style0 from "./Cleanse.vue?vue&type=style&index=0&id=03c56b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c56b7a",
  null
  
)

export default component.exports